/**
 * Autogenerated file don't modify
 */
(function () {
var tsBuild = (function (exports) {
    'use strict';

    var util = MoyaContainer.get('core.util');
    var moyaFetch = MoyaContainer.get('core.fetch');
    MoyaComponents.register('extras.service', function (el) {
        var wasteTreatmentConfig = {
            nav: el,
        };
        ExtrasService.create(wasteTreatmentConfig);
    });
    var ExtrasService = /** @class */ (function () {
        function ExtrasService(config) {
            this.nav = config.nav;
        }
        ExtrasService.create = function (config) {
            return new ExtrasService(config).run();
        };
        ExtrasService.prototype.run = function () {
            var _this = this;
            this.nav.querySelectorAll('a').forEach(function (anchor) {
                util.delegate(anchor, 'click', '#' + anchor.id, function (ev) {
                    ev.preventDefault();
                    anchor.classList.add('active');
                    _this.removeActiveFromOtherAnhors(anchor.id);
                    moyaFetch.fetchHtml(anchor.href).then(function (el) {
                        var row = el.querySelector(' #contentContainer > .contentWrap > .row');
                        row.classList.add('scale-in-center');
                        var header = row.querySelector('h1');
                        var subHeader = document.createElement('h2');
                        subHeader.innerHTML = header.innerHTML;
                        row.querySelector('h1').replaceWith(subHeader);
                        document.querySelector('#contentContainer > .contentWrap .row').outerHTML = row.outerHTML;
                    });
                });
            });
            setTimeout(function () {
                var firstItem = _this.nav.querySelector('a:first-of-type');
                if (firstItem) {
                    firstItem.click();
                }
            }, 400);
        };
        ExtrasService.prototype.removeActiveFromOtherAnhors = function (id) {
            this.nav.querySelectorAll('a').forEach(function (anchor) {
                if (anchor.id !== id) {
                    anchor.classList.remove('active');
                }
            });
        };
        return ExtrasService;
    }());

    exports.ExtrasService = ExtrasService;

    return exports;

}({}));
typeof tsBuild === 'function' && tsBuild();})();
